<!-- @formatter:off -->
<markdown clipboard mermaid ngPreserveWhitespaces>
```typescript
const column_1 = new BaseEntityAttrDescriptor('name', FormControlType.TEXT_BOX, 'Name', undefined, true);
const column_2 = new BaseEntityAttrDescriptor('description', FormControlType.TEXTAREA, 'Description');
const column_3 = new BaseEntityAttrDescriptor('testEntityId', FormControlType.FOREIGN_KEY, 'Test Entity');
column_3.disabled = true;
column_3.linkedEntityType = 'TestEntity'; export const testEntityComponentDescriptors: BaseEntityAttrDescriptor[] = [column_1, column_2, column_3];
```
</markdown>
<!-- @formatter:on -->
<base-entity-container [entityDescriptor]="entityDescriptor"></base-entity-container>
